import * as h2Api from '../h2Api'
import * as portfolioSummaryActions from '../actions/portfolioSummaryReport'
import { defaultPortfolioSummaryFilters } from '../actions/portfolioSummaryReport'
import * as adminUserActions from '../actions/admin/adminUserActions'

const initialSavedConfirm = {
  visible: false,
  loading: false,
  forUser: null
}
const initialState = {
  filters: defaultPortfolioSummaryFilters,
  summary: null,
  showSavedConfirm: initialSavedConfirm,
  flaggedItems: {}
}
const portfolioSummaryReport = (state = initialState, action) => {
  switch (action.type) {
    case portfolioSummaryActions.TOGGLE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.name]: !state.filters[action.name]
        }
      }

    case adminUserActions.CLEAR_PROFILE:
      return {
        ...state,
        showSavedConfirm: initialSavedConfirm
      }

    case portfolioSummaryActions.TOGGLE_FILTER_TO:
      const newState = {
        ...state,
        filters: action.newValues
      }

      console.log('Updated store to: ', state, newState)

      return newState

    case portfolioSummaryActions.REPORT_DATA_SAVE_PORTFOLIO:
      return {
        ...state,
        showSavedConfirm: {
          visible: false,
          error: false,
          loading: true,
          forUser: action.user ? action.user.name : null
        }
      }

    case portfolioSummaryActions.REPORT_DATA_SAVE_PORTFOLIO_COMPLETE:
      return {
        ...state,
        showSavedConfirm: {
          visible: true,
          error: false,
          loading: false,
          forUser: action.user ? action.user.name : null
        }
      }

    case portfolioSummaryActions.REPORT_DATA_SAVE_PORTFOLIO_ERROR:
      return {
        ...state,
        showSavedConfirm: {
          error: true,
          loading: false,
          forUser: action.user ? action.user.name : null
        }
      }

    case portfolioSummaryActions.REPORT_DATA_SAVE_PORTFOLIO_DISMISS:
      return {
        ...state,
        showSavedConfirm: {
          loading: false,
          error: false,
          visible: false
        }
      }

    case portfolioSummaryActions.FILTER_NUM_TO_DISPLAY:
      return {
        ...state,
        filters: {
          ...state.filters,
          numToDisplay: action.numToDisplay
        }
      }

    case portfolioSummaryActions.REPORT_DATA_LOAD:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const myMap = {}

        action.restCall.result.flags.forEach(f => {
          if (f.objectType === 'onet') {
            myMap[f.objectId] = f
          }
        })

        return {
          ...state,
          summary: action.restCall.result,
          flaggedItems: myMap
        }
      }

      return state

    default:
      return state
  }
}

export default portfolioSummaryReport
